import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'step-dialog',
    templateUrl: './step-dialog.component.html',
    styleUrls: ['./step-dialog.component.scss'],
    providers: [],
    standalone: false
})
export class StepDialogComponent implements OnInit {

  element: Models.AddressAssetModel;
  step: Models.DriverStep;
  errorMessage;

  constructor(
      public dialogRef: MatDialogRef<StepDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.step = new Models.DriverStep();
    if (this.data) {
      this.step.populateFromJSON(this.data);
    }
  }

  async ngOnInit() {
  }

  async save() {
    this.dialogRef.close(this.step);
  }
}
